<template>
    <div class="login-page">
        <div class="background-overlay"></div>

        <div class="login-container">
            <div class="login-card shadow-lg">
                <div class="card-header bg-primary text-white text-center py-4">
                    <h2 class="mb-0">
                        <i class="fas fa-lock me-2"></i>Espace Admin
                    </h2>
                </div>

                <div class="card-body p-4">
                    <form @submit.prevent="login">
                        <div class="mb-3">
                            <label for="email" class="form-label">Adresse Email</label>
                            <div class="input-group">
                                <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                                <input type="email" class="form-control" id="email" v-model="form.email"
                                    placeholder="admin@example.com" required>
                            </div>
                        </div>

                        <div class="mb-3">
                            <label for="password" class="form-label">Mot de passe</label>
                            <div class="input-group">
                                <span class="input-group-text"><i class="fas fa-key"></i></span>
                                <input type="password" class="form-control" id="password" v-model="form.password"
                                    placeholder="••••••••" required>
                            </div>
                        </div>

                        <div class="d-grid mt-4">
                            <button type="submit" class="btn btn-primary btn-lg" :disabled="loading">
                                <template v-if="!loading">
                                    <i class="fas fa-sign-in-alt me-2"></i>Connexion
                                </template>
                                <template v-else>
                                    <span class="spinner-border spinner-border-sm me-2" role="status"
                                        aria-hidden="true"></span>
                                    Connexion en cours...
                                </template>
                            </button>
                        </div>

                        <div v-if="errorMessage" class="alert alert-danger mt-4 mb-0">
                            <i class="fas fa-exclamation-circle me-2"></i>{{ errorMessage }}
                        </div>
                    </form>
                </div>

                <div class="card-footer text-center py-3">
                    <p class="text-muted small mb-0 text-white">© 2025 Asdecode - Tous droits réservés</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'LoginView',
    data() {
        return {
            form: {
                email: '',
                password: ''
            },
            loading: false,
            errorMessage: ''
        }
    },
    methods: {
        async login() {
            this.loading = true;
            this.errorMessage = '';

            try {
                const response = await this.axios.post('/api/token', this.form);

                // Vérifier que l'utilisateur est admin
                if (response.data.user.role !== 'superadmin') {
                    throw new Error('Accès réservé aux administrateurs');
                }

                const userDatas = response.data

                this.axios.defaults.headers.common = {
                    'Authorization': 'Bearer ' + userDatas.token
                };
                this.$store.commit('setAuthenticated', userDatas)

                // Rediriger vers le tableau de bord
                this.$router.push({ name: 'home' });

            } catch (error) {
                console.error('Login error:', error);

                if (error.response && error.response.data) {
                    this.errorMessage = error.response.data.message || 'Erreur de connexion';
                } else {
                    this.errorMessage = error.message || 'Erreur inconnue';
                }

            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style scoped>
.login-page {
    position: relative;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    padding: 20px;
}

.background-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 0;
}

.login-container {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 450px;
}

.login-card {
    background-color: rgb(255, 255, 255);
    border-radius: 15px;
    overflow: hidden;
    border: none;
    animation: fadeIn 0.6s ease-in-out;
}

.card-header {
    border-radius: 0 !important;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.input-group-text {
    background-color: #f8f9fa;
    border: 1px solid #ced4da;
}

.btn-primary {
    background: linear-gradient(to right, #4776E6, #8E54E9);
    border: none;
    padding: 12px;
    transition: all 0.3s ease;
}

.btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.btn-primary:disabled {
    background: #6c757d;
    transform: none;
    box-shadow: none;
}

.form-control:focus {
    box-shadow: 0 0 0 0.25rem rgba(114, 94, 195, 0.25);
    border-color: #725ec3;
}
</style>